import { type HTMLAttributes, useEffect } from "react";

import { useResizeDetector } from "react-resize-detector";
import { Box } from "@mui/material";

interface ResizableElementProps extends HTMLAttributes<HTMLDivElement> {
  width: number | string;
  onResizeElement?: (id: number, w: number | string) => void;
  colId: number;
  sx?: any;
}

export const ResizableCellHeader = (props: ResizableElementProps) => {
  const { ref, width } = useResizeDetector({ skipOnMount: true });
  const { onResizeElement, colId } = props;
  useEffect(() => {
    if (width && onResizeElement) {
      onResizeElement(colId, width);
    }
  }, [width, onResizeElement, colId]);

  useEffect(() => {
    if (props.width && onResizeElement) {
      onResizeElement(colId, props.width);
    }
  }, [onResizeElement, colId, props.width]);

  return (
    <Box
      ref={ref}
      style={{
        resize: "horizontal",
        width: props.width,
      }}
      sx={props.sx}
    >
      {props.title}
    </Box>
  );
};
